module.exports = __webpack_public_path__ + "img/1-4.0f1fb1b1.jpg";